import styled, { css } from "styled-components";

const DropdownWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	transform: rotate(0deg);
	height: 40px;
	padding: 5px 10px;
	gap: 5px;
	align-self: stretch;
	max-width: 180px;
	min-width: 180px;
	cursor: pointer;

	img {
		width: 30px;
	}

	svg {
		width: 24px;
		height: 24px;
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				&:last-of-type {
					transform: rotate(180deg);
					animation: rotate 0.1s;
				}
			}
		`}

	${({ isDropdownOpen }) =>
		isDropdownOpen &&
		css`
			display: flex;
			height: 40px;
			padding: 10px;
			align-items: center;
			gap: 5px;
			align-self: stretch;
			border-radius: 20px 20px 0 0;
			background: linear-gradient(0deg, #191726 0%, #050512 100%);
			box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
			backdrop-filter: blur(15px);
		`}
`;

const HeaderText = styled.div`
	display: flex;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;
`;

const StyledMenu = styled.div`
	list-style: none;
	display: flex;
	flex-direction: column;
	color: var(--main-secondary-text-color);
	max-width: 180px;
	min-width: 180px;
	opacity: 1;
	position: relative;
	z-index: 999;
	border-radius: 0 0 20px 20px;
	background: var(--modal-bg);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(15px);
	font-size: 14px;
	font-weight: 400;
	line-height: 28px;
	letter-spacing: 0.3px;
`;

const StyledMenuItem = styled.div`
	display: flex;
	height: 40px;
	padding: 5px 10px;
	align-items: center;
	gap: 5px;
	align-self: stretch;
	cursor: pointer;

	img {
		width: 30px;
	}

	svg {
		width: 24px;
		height: 24px;
		path {
			fill: var(--main-secondary-text-color);
		}
	}

	&:last-of-type {
		padding: 5px 10px 10px;
	}
`;

export { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem };
